<template>
  <div class="weather-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="时间格式"
          name="2"
        >
          <div
            class="setting-item clearFloat"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content">
              <div class="verticallyCenter">
                <span class="font14 mr10 mb10" style="width: 57px">日期格式</span>
                <el-select popper-class="date-style-select" class="mb10" v-model="dateStyle" placeholder="请选择">
                  <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="verticallyCenter">
                <span class="font14 mr10" style="width: 57px">星期格式</span>
                <el-select class="" v-model="weekStyle" placeholder="请选择">
                  <el-option v-for="item in weekStyleOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="verticallyCenter mt16">
                <cx-check-box :value.sync="showLunar">显示农历</cx-check-box>
                <cx-check-box :value.sync="showSolarTerms" class="ml12">显示节气</cx-check-box>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="文字"
          name="3"
        >
          <div
            class="setting-item clearFloat mb16"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <div class="content">
              <!-- 字体和颜色/字重和字号 -->
              <text-setting-complex-update
                class="mb16"
                :options="options"
                :fontFamily.sync="fontFamily"
                :fontSize.sync="fontSize"
                :fontWeight.sync="fontWeight"
                :fontStyle.sync="fontStyle"
                :textDecoration.sync="textDecoration"
                :lineHeight.sync="lineHeight"
                :letterSpacing.sync="letterSpacing"
                :activeArrangement.sync="activeArrangement"
                :writingMode.sync="writingMode"
                :textAlign.sync="textAlign"
                :activeArrangementOrder.sync="activeArrangementOrder"
                :lineHeightType.sync="lineHeightType"
                :letterSpacingType.sync="letterSpacingType"
                :colorArr.sync="color"
                :showColorSet="false"
              />
              <div>
                <div class="mt16">
                  <el-radio-group v-model="colorType" style="height: 20px">
                    <el-radio label="纯色">纯色</el-radio>
                    <el-radio label="线性渐变">线性渐变</el-radio>
                  </el-radio-group>
                </div>
                <color-picker-theme-color
                  :isThemeColor.sync="textIsThemeColor"
                  :color.sync="color"
                  v-if="colorType === '纯色'"
                  class="custom-text-bg mt16 custom-text-bg1"
                >
                </color-picker-theme-color>
                <div v-if="colorType === '线性渐变'" class="mt16">
                  <span class="mr16 fs14">开始颜色</span>
                  <div class="color-picker-container custom-text-bg">
                    <el-color-picker
                      class=""
                      v-model="startColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ startColor }}</span>
                  </div>
                </div>
                <div v-if="colorType === '线性渐变'" class="mt16">
                  <span class="mr16 fs14">结束颜色</span>
                  <div class="color-picker-container custom-text-bg">
                    <el-color-picker
                      class=""
                      v-model="endColor"
                      color-format="rgb"
                      :show-alpha="true"
                    ></el-color-picker>
                    <span class="floatLeft color-text mr8">{{ endColor }}</span>
                  </div>
                </div>
                <div v-if="colorType !== '纯色'" class="mt16">
                  <p class="mr16 fs14">渐变角度</p>
                  <div class="slider-input-container paddingl0">
                    <slider-and-input
                      class="mb16"
                      inputWidth="small"
                      inputHeight="small"
                      :value.sync="colorlinearGradientAngle"
                      :sliderMin="0"
                      :sliderMax="360"
                      suffix="度"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"

export default {
  name: "date-options-data",
  components: {
    controlWidthAndSizeAndZindex,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      this1: this,
      collapseActiveNames: ["1", "2", "3", "4"],
      activeType: 1,
      sliderMax: 360,
      fontFamilyList: [
        {
          value: "默认",
          label: "default"
        },
        {
          value: "默认字体",
          label: "PingFang SC"
        }
      ],
      bgTypes: [
        {
          name: "主题色"
        },
        {
          name: "自定义"
        }
      ],
      dateOptions: [
        {
          value: "1",
          label: "2021年11月24日"
        },
        {
          value: "2",
          label: "2021年11月24日 12时00分00秒"
        },
        {
          value: "3",
          label: "2021-11-24"
        },
        {
          value: "4",
          label: "2021-11-24 12:00:00"
        },
        {
          value: "5",
          label: "2021/11/24"
        },
        {
          value: "6",
          label: "2021/11/24 12:00:00"
        },
        {
          value: "7",
          label: "12:00:00"
        }
      ],
      weekStyleOptions: [
        {
          value: "1",
          label: "不显示"
        },
        {
          value: "2",
          label: "星期一"
        },
        {
          value: "3",
          label: "周一"
        }
      ]
    }
  },
  comments: {},
  created() {},

  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    activeArrangement() {
      return this.options.textAlign || "left"
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "deg", "rotate", false)
      }
    },
    weekStyle: {
      get() {
        return this.options.weekStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "weekStyle", false)
      }
    },
    dateStyle: {
      get() {
        return this.options.dateStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "dateStyle", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "主题色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    colorType: {
      get() {
        return this.options.colorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorType", false)
      }
    },
    startColor: {
      get() {
        return this.options.startColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startColor", false)
      }
    },
    endColor: {
      get() {
        return this.options.endColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endColor", false)
      }
    },
    colorlinearGradientAngle: {
      get() {
        return this.options.colorlinearGradientAngle || 90
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "colorlinearGradientAngle", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor || "#fff"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign || "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight || 50
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode || "horizontal-tb"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration || "none"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    showLunar: {
      get() {
        return this.options.showLunar || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showLunar", false)
      }
    },
    showSolarTerms: {
      get() {
        return this.options.showSolarTerms || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showSolarTerms", false)
      }
    },
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    changeStyle(flag, temp, hoverFlag) {
      let curFontStyleList = hoverFlag ? "hoverFontStyleList" : "fontStyleList"
      switch (flag) {
        case 0:
          let fontWeightName = hoverFlag ? hoverFlag + "FontWeight" : "fontWeight"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[fontWeightName] = 400
          } else {
            this[curFontStyleList][flag].isActive = true
            this[fontWeightName] = 500
          }
          break
        case 1:
          let fontStyleName = hoverFlag ? hoverFlag + "FontStyle" : "fontStyle"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[fontStyleName] = "normal"
          } else {
            this[curFontStyleList][flag].isActive = true
            this[fontStyleName] = "italic"
          }
          break
        case 2:
          let textDecorationName = hoverFlag ? hoverFlag + "TextDecoration" : "textDecoration"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[textDecorationName] = "none"
          } else {
            this[curFontStyleList][flag].isActive = true
            this[textDecorationName] = "underline"
          }
          break
      }
    },
    changeArrangement(val, hoverFlag) {
      let cutTextAlign = hoverFlag ? hoverFlag + "TextAlign" : "textAlign"
      this[cutTextAlign] = val.value
    },
    changeArrangementOrder(flag, hoverFlag) {
      let curActiveArrangementOrder = hoverFlag ? hoverFlag + "ActiveArrangementOrder" : "activeArrangementOrder"
      let curWritingMode = hoverFlag ? hoverFlag + "WritingMode" : "writingMode"

      if (flag) {
        this[curActiveArrangementOrder].isActive = false
        // this[curWritingMode] = "horizontal-tb"
        this.$changeOptionsEV("horizontal-tb", curWritingMode, false)
      } else {
        this[curActiveArrangementOrder].isActive = true
        // this[curWritingMode] = "vertical-lr"
        this.$changeOptionsEV("vertical-lr", curWritingMode, false)
      }
    }
  }
}
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.w172 {
  width: 172px;
}
.w180 {
  width: 180px;
}
::v-deep.custom-date-color .el-color-picker,
::v-deep.custom-date-color .el-color-picker__trigger {
  width: 100%;
}
::v-deep .color-picker-container.custom-text-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
::v-deep .color-picker-container.custom-text-bg.custom-text-bg1{
  width: 100%;
}
.paddingl0 {
  padding-left: 0;
}
::v-deep.el-select:hover .el-input__inner {
  border-color: rgba(23, 112, 255, 1);
}
.weather-options-setting-dialog ::v-deep.font-arrangement-btn {
  border: none;
  padding: 2px;
}
</style>
